import React from 'react'
import { Field, FieldProps, FormikProps } from 'formik'
import { SingleDateInput } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

import { ModifyContractInput } from '../../../../../common/validations'
import FormFieldWrapper from '../../../../components/FormField'
import { FormFieldDescription } from '../../../../components/FormField/FormFieldDescription'
import { renderDate, safeISODateFromLocaleDate } from '../../../../utils'

export type ModificationInEffectFieldProps = {
  form: FormikProps<ModifyContractInput>
  description: string | undefined
  allowedDates: Date[] | undefined
  disabledBefore: DateTime
  disabledAfter: DateTime
}

export const ModificationInEffectField: React.FC<
  ModificationInEffectFieldProps
> = ({ form, description, allowedDates, disabledBefore, disabledAfter }) => {
  const { t } = useTranslation(['common', 'contractModification'])

  return (
    <Field name="inEffect">
      {({ field, meta }: FieldProps<ModifyContractInput['inEffect']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('contractModification:labels.movingOutDate')}
          className="min-tablet:max-w-80 mt-8"
          meta={meta}
          labelBold
          required
          description={
            description && <FormFieldDescription text={description} />
          }
        >
          <SingleDateInput
            {...field}
            value={renderDate(field.value)}
            onChange={async (value) => {
              const date = safeISODateFromLocaleDate(value)

              if (date) {
                await form.setFieldValue(field.name, date, true)
              } else {
                form.setFieldValue(field.name, value, false)
              }

              await form.setFieldTouched(field.name, true)
            }}
            allowedDates={allowedDates}
            disabledAfter={disabledAfter.toJSDate()}
            disabledBefore={disabledBefore.toJSDate()}
            placeholder={t('common:placeholders.date')}
            datePickerPosition="bottomLeft"
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
